import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { Field, FormikProvider, useFormik } from "formik";
import * as Yup from "yup";
import { Col, Form, Row } from "react-bootstrap";
import CustomInput from "../../../CustomControls/CustomInput";
import CustomSelect from "../../../CustomControls/CustomSelect";
import CustomFlatpickr from "../../../CustomControls/CustomFlatpickr";
import moment from "moment";
import { Spin } from "antd";
import { post } from "../../../helpers/api_helper";
import {
  POST_CreditNoteInsert,
  POST_CreditNoteUpdate,
  POST_GetCreditNoteDetailByID,
  POST_GetCreditNoteInvoiceDetailByID,
  POST_GetCreditNoteInvoiceDropDownList,
  POST_GetCustomerDDLListAJAX,
  POST_GetVoucherSeriesDDLList,
} from "../../../helpers/url_helper";
import { errorMessage, successMessage } from "../CommonFunctions";
import CustomSelectAsync from "../../../CustomControls/CustomSelectAsync";
import CommonMaterialInformation from "../Invoice/CommonMaterialInformation";
import CustomTextArea from "../../../CustomControls/CustomTextArea";

const AddCreditNote = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  const { PrimaryIdParam } = useParams();

  const AuthUser = JSON.parse(localStorage.getItem("userDetails"));

  const [creditNoteNoOptions, setCreditNoteNoOptions] = useState([]);
  const [invoiceNoOptions, setInvoiceNoOptions] = useState([]);

  const validationSchema = Yup.object().shape({
    VoucherSeriesIDEncrypted: Yup.string().required(
      "Credit Note No is required field"
    ),
    CreditNoteDate: Yup.string().required("Credit Note Date is required field"),
    CustomerIDEncrypted: Yup.string().required("Customer is required field"),
    InvoiceIDEncrypted: Yup.string().required("Invoice No is required field"),
  });

  const formik = useFormik({
    validationSchema,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmit(values, formikHelpers),
    initialValues: {
      CreditNoteIDEncrypted: PrimaryIdParam ? window.atob(PrimaryIdParam) : "",
      VoucherSeriesIDEncrypted: "",
      CreditNoteNo: "",
      CreditNoteDate: new Date(),
      CustomerIDEncrypted: "",
      CustomerName: "",
      InvoiceIDEncrypted: "",
      InvoiceNo: "",
      Reason: "",
      BuyerDebitNo: "",
      BuyerDebitDate: "",
      IsFullyOrPatrial: true,
      ListOfInwardMaterialsDetails: [],
      ListOfExpense: [],
      DiscountPercentageApplyToAll: "",
      ListOfGSTPlans: [],
      GSTType: 0,
      CalculateGST: true,
      GSTPercentage: "0.00",
      GrossAmount: "0.00", ///* Item wise Total Amount */
      ItemTotalDiscountAmount: "0.00", ///* Item wise Total Discount Amount */
      ItemNetAmount: "0.00", ///* Item wise Total Net Amount */
      AdditionalAmount: "0.00", ///* Expense Total Amount */
      ExpenseTotalDiscountAmount: "0.00", ///* Expense Total Discount Amount */
      ExpenseNetAmount: "0.00", ///* Expense Total NetAmount */
      TotalGrossAmount: "0.00", ///* ItemNetAmount + ExpenseNetAmount */
      DiscountAmount: "0.00", ///* ItemTotalDiscountAmount + ExpenseTotalDiscountAmount */
      GSTAmount: "0.00", ///* Total GST Tax Amount */
      RoundingOff: "0.00", ///* Rounding Amount */
      NetAmount: "0.00", ///* TotalGrossAmount + Total Tax Amount */
      FormID: 63, ///* 63 = Credit Note */
      calcGross: false,
      calcTaxAndNet: false,
      GenerateEInvoice: false,
      GSTNumber: "",
      GSTRegistrationType: 0,
      eInvoiceStatus: false,
    },
    validateOnBlur: false,
  });

  const {
    values: {
      CreditNoteIDEncrypted,
      VoucherSeriesIDEncrypted,
      CreditNoteDate,
      CustomerIDEncrypted,
      CustomerName,
      InvoiceIDEncrypted,
      IsFullyOrPatrial,
      BuyerDebitDate,
      GenerateEInvoice,
      GSTRegistrationType,
      GSTNumber,
      eInvoiceStatus,
    },
  } = formik;

  const handleValidSubmit = (values) => {
    setIsLoading(true);

    let inwardList = [],
      testList = [],
      machiningList = [],
      expenseList = [];

    Promise.all(
      values?.ListOfInwardMaterialsDetails?.filter(
        (x) => x.IsSelected == true
      )?.map((item) => {
        inwardList.push({
          InwardIDEncrypted: item?.InwardIDEncrypted,
          InwardMaterialIDEncrypted: item?.InwardMaterialIDEncrypted,
          PerformaInvoiceIDEncrypted: item?.PerformaInvoiceIDEncrypted,
        });
        item?.ListOfTests?.map((test) => {
          testList.push({
            ...test,
            DiscountPercentage: test?.DiscountPercentage
              ? test?.DiscountPercentage
              : "0.00",
            UnitID: test?.UnitID ? test?.UnitID : 0,
          });
        });
        item?.ListOfMachining?.map((machining) => {
          machiningList.push({
            ...machining,
            DiscountPercentage: machining?.DiscountPercentage
              ? machining?.DiscountPercentage
              : "0.00",
          });
        });
      })
    );

    Promise.all(
      values?.ListOfExpense?.filter((x) => x.IsSelected == true)?.map(
        (item) => {
          expenseList.push({
            ...item,
            DiscountPercentage: item?.DiscountPercentage
              ? item?.DiscountPercentage
              : "0.00",
          });
        }
      )
    );

    let payload = {
      ...values,
      CreditNoteDate: values?.CreditNoteDate
        ? moment(values?.CreditNoteDate).format("YYYY-MM-DD").replace(/^\-/, "")
        : "",
      DiscountAmount: values?.DiscountAmount?.toString(),
      InwardList: inwardList,
      TestList: testList,
      MachiningList: machiningList,
      ExpenseList: expenseList,
      GSTDetail: values?.ListOfGSTPlans,
      BuyerDebitDate: values?.BuyerDebitDate
        ? moment(values?.BuyerDebitDate).format("YYYY-MM-DD").replace(/^\-/, "")
        : "",
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
      CreatedByEncrypted: AuthUser?.ReferenceIDEncrypt,
      ModifiedByEncrypted: AuthUser?.ReferenceIDEncrypt,
    };

    delete payload["ListOfInwardMaterialsDetails"];
    delete payload["ListOfExpense"];
    delete payload["ListOfGSTPlans"];
    delete payload["unitOptions"];
    delete payload["FormID"];
    delete payload["calcGross"];
    delete payload["calcTaxAndNet"];
    //console.log(payload);

    post(
      values?.CreditNoteIDEncrypted
        ? POST_CreditNoteUpdate
        : POST_CreditNoteInsert,
      payload
    )
      .then((response) => {
        setIsLoading(true);
        if (response?.IsSuccess) {
          successMessage(response?.Message);
          setTimeout(() => {
            navigate(-1);
          }, 1000);
        } else {
          errorMessage(response?.Message);
          setIsLoading(false);
        }
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  useEffect(() => {
    if (PrimaryIdParam) {
      getCreditNoteDetails();
    }
  }, []);

  const getCreditNoteDetails = async () => {
    setIsLoading(true);
    await post(POST_GetCreditNoteDetailByID, {
      CreditNoteIDEncrypted: window.atob(PrimaryIdParam),
    })
      .then((response) => {
        if (response?.IsSuccess) {
          let p = response?.CreditNoteInfo;
          formik.setFieldValue(
            "VoucherSeriesIDEncrypted",
            p?.VoucherSeriesIDEncrypted
          );
          formik.setFieldValue("CreditNoteNo", p?.CreditNoteNo);
          formik.setFieldValue(
            "CreditNoteDate",
            p?.CreditNoteDate ? new Date(p?.CreditNoteDate) : ""
          );
          formik.setFieldValue("CustomerIDEncrypted", p?.CustomerIDEncrypted);
          formik.setFieldValue("CustomerName", p?.CustomerName);
          formik.setFieldValue("InvoiceIDEncrypted", p?.InvoiceIDEncrypted);
          formik.setFieldValue("InvoiceNo", p?.InvoiceNo);
          formik.setFieldValue("Reason", p?.Reason);
          formik.setFieldValue("BuyerDebitNo", p?.BuyerDebitNo);
          formik.setFieldValue(
            "BuyerDebitDate",
            p?.BuyerDebitDate ? new Date(p?.BuyerDebitDate) : ""
          );
          formik.setFieldValue("IsFullyOrPatrial", p?.IsFullyOrPatrial);
          formik.setFieldValue(
            "ListOfInwardMaterialsDetails",
            response?.ListOfInwardMaterialsDetails
          );
          formik.setFieldValue("ListOfExpense", response?.ExpenseList);
          formik.setFieldValue("ListOfGSTPlans", response?.GSTList);
          formik.setFieldValue("GSTType", p?.GSTType);
          formik.setFieldValue("GSTPercentage", p?.GSTPercentage);
          formik.setFieldValue("GSTNumber", p?.GSTNo);
          formik.setFieldValue("GSTRegistrationType", p?.GSTRegistrationType);
          formik.setFieldValue("GenerateEInvoice", p?.GenerateEInvoice);
          formik.setFieldValue("eInvoiceStatus", p?.GenerateEInvoice);
          formik.setFieldValue("GrossAmount", p?.GrossAmount);
          let itemTotalDiscountAmount = 0,
            itemNetAmount = 0,
            expenseTotalDiscountAmount = 0,
            expenseNetAmount = 0,
            totalGrossAmount = 0;
          Promise.all(
            response?.ListOfInwardMaterialsDetails?.map((item) => {
              Promise.all(
                item?.ListOfTests?.map((test) => {
                  if (item.IsSelected == true) {
                    itemTotalDiscountAmount =
                      itemTotalDiscountAmount +
                      parseFloat(
                        test?.DiscountAmount ? test?.DiscountAmount : 0
                      );
                    itemNetAmount =
                      itemNetAmount +
                      parseFloat(test?.NetAmount ? test?.NetAmount : 0);
                  }
                })
              );
              Promise.all(
                item?.ListOfMachining?.map((m) => {
                  if (item.IsSelected == true) {
                    itemTotalDiscountAmount =
                      itemTotalDiscountAmount +
                      parseFloat(m?.DiscountAmount ? m?.DiscountAmount : 0);
                    itemNetAmount =
                      itemNetAmount +
                      parseFloat(m?.NetAmount ? m?.NetAmount : 0);
                  }
                })
              );
            })
          );
          Promise.all(
            response?.ExpenseList?.filter((x) => x.IsSelected == true)?.map(
              (e) => {
                expenseTotalDiscountAmount =
                  expenseTotalDiscountAmount +
                  parseFloat(e?.DiscountAmount ? e?.DiscountAmount : 0);
                expenseNetAmount =
                  expenseNetAmount +
                  parseFloat(e?.NetAmount ? e?.NetAmount : 0);
              }
            )
          );
          totalGrossAmount =
            parseFloat(itemNetAmount) + parseFloat(expenseNetAmount);
          formik.setFieldValue(
            "ItemTotalDiscountAmount",
            itemTotalDiscountAmount.toFixed(2)
          );
          formik.setFieldValue("ItemNetAmount", itemNetAmount.toFixed(2));
          formik.setFieldValue("AdditionalAmount", p?.AdditionalAmount);
          formik.setFieldValue(
            "ExpenseTotalDiscountAmount",
            expenseTotalDiscountAmount.toFixed(2)
          );
          formik.setFieldValue("ExpenseNetAmount", expenseNetAmount.toFixed(2));
          formik.setFieldValue("TotalGrossAmount", totalGrossAmount.toFixed(2));
          formik.setFieldValue("DiscountAmount", p?.DiscountAmount);
          formik.setFieldValue("GSTAmount", p?.GSTAmount);
          formik.setFieldValue("RoundingOff", p?.RoundingOff);
          formik.setFieldValue("NetAmount", p?.NetAmount);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  useEffect(() => {
    if (!CreditNoteDate) {
      formik.setFieldValue("CreditNoteDate", "");
    }
    getCreditNoteNoDDL();
  }, [CreditNoteDate]);

  useEffect(() => {
    if (!BuyerDebitDate) {
      formik.setFieldValue("BuyerDebitDate", "");
    }
  }, [BuyerDebitDate]);

  const getCreditNoteNoDDL = async () => {
    setIsLoading(true);
    await post(POST_GetVoucherSeriesDDLList, {
      TranType: 18, // 18 = Credit Note
      TranDate: CreditNoteDate
        ? moment(CreditNoteDate).format("YYYY-MM-DD").replace(/^\-/, "")
        : "",
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          setCreditNoteNoOptions(
            response?.VoucherSeriesList?.map((item) => ({
              label: item.VoucherSeries,
              value: item.VoucherSeriesIDEncrypt,
            }))
          );
          if (VoucherSeriesIDEncrypted) {
            if (
              response?.VoucherSeriesList?.filter(
                (x) => x.VoucherSeriesIDEncrypt == VoucherSeriesIDEncrypted
              )?.length == 0
            ) {
              formik.setFieldValue("VoucherSeriesIDEncrypted", "");
            }
          } else {
            /*select the value when there is only one option while insert only*/
            if (response?.VoucherSeriesList?.length == 1 && !PrimaryIdParam) {
              formik.setFieldValue(
                "VoucherSeriesIDEncrypted",
                response?.VoucherSeriesList[0].VoucherSeriesIDEncrypt
              );
            }
          }
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const loadOptionsCutomer = (inputValue) => {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve(getCustomerDDL_AJAX(inputValue));
      }, 1000);
    });
  };

  const getCustomerDDL_AJAX = async (inputValue) => {
    return await post(POST_GetCustomerDDLListAJAX, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      SearchValue: inputValue ?? "",
      TPIFlag: -1, // 0 = Only Customer, 1 = Only TPI,  -1 = All (Customer & TPI both)
    })
      .then((response) => {
        if (response?.IsSuccess) {
          return response?.CustomerDDLList?.map((item) => ({
            label: item.CustomerName,
            value: item.CustomerIDEncrypted,
          }));
        } else {
          return [];
        }
      })
      .catch((error) => {
        console.log(error);
        return [];
      });
  };

  const getInvoiceList = async (customerID) => {
    if (customerID) {
      setIsLoading(true);
      await post(POST_GetCreditNoteInvoiceDropDownList, {
        CustomerIDEncrypted: customerID,
        CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
        BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
      })
        .then((response) => {
          if (response?.IsSuccess) {
            setInvoiceNoOptions(
              response?.InvoiceDDL?.map((item) => ({
                label: item.InvoiceNo,
                value: item.InvoiceIDEncrypted,
              }))
            );
          }
          setIsLoading(false);
        })
        .catch((error) => {
          console.log(error);
          setIsLoading(false);
        });
    } else {
      setInvoiceNoOptions([]);
      formik.setFieldValue("InvoiceID", "");
    }
  };

  const getInvoiceDetails = async (invoiceID) => {
    if (invoiceID) {
      setIsLoading(true);
      await post(POST_GetCreditNoteInvoiceDetailByID, {
        InvoiceIDEncrypted: invoiceID,
        CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
        BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
      })
        .then((response) => {
          if (response?.IsSuccess) {
            let p = response?.InvoiceInfo;
            formik.setFieldValue("InvoiceNo", p?.InvoiceNo);
            formik.setFieldValue(
              "ListOfInwardMaterialsDetails",
              response?.ListOfInwardMaterialsDetails
            );
            formik.setFieldValue("ListOfExpense", response?.ExpenseList);
            formik.setFieldValue("ListOfGSTPlans", response?.GSTList);
            formik.setFieldValue("GSTType", p?.GSTType);
            formik.setFieldValue("GSTPercentage", p?.GSTPercentage);
            formik.setFieldValue("GSTNumber", p?.GSTNo);
            formik.setFieldValue("GSTRegistrationType", p?.GSTRegistrationType);
            formik.setFieldValue(
              "GenerateEInvoice",
              AuthUser?.EInvoiceApplicable == true ? p?.GenerateEInvoice : false
            );
            formik.setFieldValue("GrossAmount", p?.GrossAmount);
            let itemTotalDiscountAmount = 0,
              itemNetAmount = 0,
              expenseTotalDiscountAmount = 0,
              expenseNetAmount = 0,
              totalGrossAmount = 0;
            Promise.all(
              response?.ListOfInwardMaterialsDetails?.map((item) => {
                Promise.all(
                  item?.ListOfTests?.map((test) => {
                    if (item.IsSelected == true) {
                      itemTotalDiscountAmount =
                        itemTotalDiscountAmount +
                        parseFloat(
                          test?.DiscountAmount ? test?.DiscountAmount : 0
                        );
                      itemNetAmount =
                        itemNetAmount +
                        parseFloat(test?.NetAmount ? test?.NetAmount : 0);
                    }
                  })
                );
                Promise.all(
                  item?.ListOfMachining?.map((m) => {
                    if (item.IsSelected == true) {
                      itemTotalDiscountAmount =
                        itemTotalDiscountAmount +
                        parseFloat(m?.DiscountAmount ? m?.DiscountAmount : 0);
                      itemNetAmount =
                        itemNetAmount +
                        parseFloat(m?.NetAmount ? m?.NetAmount : 0);
                    }
                  })
                );
              })
            );
            Promise.all(
              response?.ExpenseList?.filter((x) => x.IsSelected == true)?.map(
                (e) => {
                  expenseTotalDiscountAmount =
                    expenseTotalDiscountAmount +
                    parseFloat(e?.DiscountAmount ? e?.DiscountAmount : 0);
                  expenseNetAmount =
                    expenseNetAmount +
                    parseFloat(e?.NetAmount ? e?.NetAmount : 0);
                }
              )
            );
            totalGrossAmount =
              parseFloat(itemNetAmount) + parseFloat(expenseNetAmount);
            formik.setFieldValue(
              "ItemTotalDiscountAmount",
              itemTotalDiscountAmount.toFixed(2)
            );
            formik.setFieldValue("ItemNetAmount", itemNetAmount.toFixed(2));
            formik.setFieldValue("AdditionalAmount", p?.AdditionalAmount);
            formik.setFieldValue(
              "ExpenseTotalDiscountAmount",
              expenseTotalDiscountAmount.toFixed(2)
            );
            formik.setFieldValue(
              "ExpenseNetAmount",
              expenseNetAmount.toFixed(2)
            );
            formik.setFieldValue(
              "TotalGrossAmount",
              totalGrossAmount.toFixed(2)
            );
            formik.setFieldValue("DiscountAmount", p?.DiscountAmount);
            formik.setFieldValue("GSTAmount", p?.GSTAmount);
            formik.setFieldValue("RoundingOff", p?.RoundingOff);
            formik.setFieldValue("NetAmount", p?.NetAmount);
          }
          setIsLoading(false);
        })
        .catch((error) => {
          console.log(error);
          setIsLoading(false);
        });
    } else {
      formik.setFieldValue("ListOfInwardMaterialsDetails", []);
      formik.setFieldValue("ListOfExpense", []);
      formik.setFieldValue("ListOfGSTPlans", []);
      formik.setFieldValue("calcGross", true);
    }
  };

  const handleChangeCustomer = (e) => {
    formik.setFieldValue("CustomerIDEncrypted", e?.value ?? "");
    formik.setFieldValue("CustomerName", e?.label ?? "");
    if ((e?.value ?? "") !== CustomerIDEncrypted) {
      setInvoiceNoOptions([]);
      formik.setFieldValue("InvoiceIDEncrypted", "");
      getInvoiceList(e?.value ?? "");
      formik.setFieldValue("ListOfInwardMaterialsDetails", []);
      formik.setFieldValue("ListOfExpense", []);
      formik.setFieldValue("ListOfGSTPlans", []);
      formik.setFieldValue("calcGross", true);
    }
  };

  const handleChangeInvoiceNo = (e) => {
    formik.setFieldValue("InvoiceIDEncrypted", e?.value ?? "");
    if ((e?.value ?? "") !== InvoiceIDEncrypted) {
      getInvoiceDetails(e?.value ?? "");
    }
  };

  return (
    <>
      <div className="card m-1">
        <div className="card-body p-1">
          <Spin
            size="large"
            spinning={isLoading}
            tip={"Loading..."}
            style={{ position: "fixed" }}
          >
            <div className="d-flex justify-content-between">
              <div className="tbl-caption p-2">
                <h4 className="heading mb-0">
                  {PrimaryIdParam ? "Edit" : "Add"} Credit Note
                </h4>
              </div>
              {GSTRegistrationType == 1 &&
                GSTNumber != "" &&
                AuthUser?.EInvoiceApplicable == true && (
                  <div
                    className={`d-flex align-items-center pe-2 ${
                      !PrimaryIdParam || eInvoiceStatus == false
                        ? ""
                        : "disableDiv"
                    }`}
                  >
                    <input
                      type="checkbox"
                      className="form-check-input mt-0"
                      id={"chkGenerateEInvoice"}
                      name={"chkGenerateEInvoice"}
                      checked={GenerateEInvoice}
                      onChange={(e) => {
                        formik.setFieldValue(
                          "GenerateEInvoice",
                          e.target.checked
                        );
                      }}
                    />
                    <label className="mb-1 ps-2">Generate E-Invoice</label>
                  </div>
                )}
            </div>
            <hr className="mt-0 mb-1"></hr>
            <div className="p-2 pt-0">
              <FormikProvider value={formik}>
                <Form onSubmit={formik.handleSubmit}>
                  <div
                    className={`${
                      !PrimaryIdParam || eInvoiceStatus == false
                        ? ""
                        : "disableDiv"
                    }`}
                  >
                    <Row>
                      <Col lg={2}>
                        <Field
                          label="Credit Note Date"
                          name="CreditNoteDate"
                          placeholder={"Select Credit Note Date"}
                          component={CustomFlatpickr}
                          options={{
                            altInput: true,
                            altFormat: "j-M-Y",
                            dateFormat: "d-m-Y",
                            maxDate: new Date(),
                          }}
                          required
                        />
                      </Col>
                      <Col lg={3}>
                        {!PrimaryIdParam ? (
                          <Field
                            label="Credit Note No"
                            name="VoucherSeriesIDEncrypted"
                            placeholder={"Select Credit Note No"}
                            options={creditNoteNoOptions}
                            component={CustomSelect}
                            required
                            autoFocus
                          />
                        ) : (
                          <Field
                            label="Credit Note No"
                            name="CreditNoteNo"
                            component={CustomInput}
                            required
                            disabled={true}
                          />
                        )}
                      </Col>
                      <Col lg={3}>
                        {!PrimaryIdParam ? (
                          <Field
                            label="Customer"
                            name="CustomerIDEncrypted"
                            placeholder={"Select Customer"}
                            loadOptionsFn={loadOptionsCutomer}
                            component={CustomSelectAsync}
                            title={CustomerName}
                            labelFieldName="CustomerName"
                            required
                            onChange={handleChangeCustomer}
                          />
                        ) : (
                          <Field
                            label="Customer"
                            name="CustomerName"
                            component={CustomInput}
                            required
                            disabled={true}
                          />
                        )}
                      </Col>
                      <Col lg={3}>
                        {!PrimaryIdParam ? (
                          <Field
                            label="Invoice No"
                            name="InvoiceIDEncrypted"
                            placeholder={"Select Invoice No"}
                            options={invoiceNoOptions}
                            component={CustomSelect}
                            onChange={handleChangeInvoiceNo}
                            menuPosition="fixed"
                            required
                          />
                        ) : (
                          <Field
                            label="Invoice No"
                            name="InvoiceNo"
                            component={CustomInput}
                            required
                            disabled={true}
                          />
                        )}
                      </Col>
                      <Col lg={1}>
                        <label></label>
                        <div className="d-flex mb-2">
                          <label>Fully &nbsp;</label>
                          <div className="form-check form-switch">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              role="switch"
                              id="flexSwitchCheckIsFullyOrPartial"
                              title={IsFullyOrPatrial == true ? "Yes" : "No"}
                              checked={IsFullyOrPatrial}
                              onChange={() => {
                                formik.setFieldValue(
                                  "IsFullyOrPatrial",
                                  !IsFullyOrPatrial
                                );
                              }}
                              style={{ cursor: "pointer" }}
                              disabled={PrimaryIdParam ? true : false}
                            ></input>
                          </div>
                        </div>
                      </Col>
                    </Row>
                    <hr className="mt-1 mb-1"></hr>
                    <CommonMaterialInformation />
                    <hr className="mt-1 mb-1"></hr>
                    <Row>
                      <Col lg={6}>
                        <Field
                          label="Reason"
                          name="Reason"
                          placeholder={"Enter Reason"}
                          component={CustomTextArea}
                          maxLength={1000}
                        />
                      </Col>
                      <Col lg={3}>
                        <Field
                          label="Buyer Debit No"
                          name="BuyerDebitNo"
                          placeholder={"Enter Buyer Debit No"}
                          component={CustomInput}
                          maxLength={100}
                        />
                      </Col>
                      <Col lg={3}>
                        <Field
                          label="Buyer Debit Date"
                          name="BuyerDebitDate"
                          placeholder={"Select Buyer Debit Date"}
                          component={CustomFlatpickr}
                          options={{
                            altInput: true,
                            altFormat: "j-M-Y",
                            dateFormat: "d-m-Y",
                          }}
                        />
                      </Col>
                    </Row>
                  </div>
                  <div className="stickyBottomButtons">
                    <hr className="mt-1 mb-2"></hr>
                    {(!PrimaryIdParam || eInvoiceStatus == false) && (
                      <button
                        type="submit"
                        className="btn btn-primary btn-sm me-2"
                      >
                        <i className="fa-solid fa-floppy-disk"></i> Submit
                      </button>
                    )}
                    <button
                      type="button"
                      className="btn btn-danger btn-sm"
                      onClick={(e) => {
                        navigate(-1);
                      }}
                    >
                      <i className="fa fa-cancel"></i> Cancel
                    </button>
                  </div>
                </Form>
              </FormikProvider>
            </div>
          </Spin>
        </div>
      </div>
    </>
  );
};

export default AddCreditNote;
